import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * useCaptureReferral
 * ------------------
 * On any page load, if the URL contains a `?ref=CODE` query param, persist it
 * to sessionStorage so a subsequent email signup can attach it as the referrer.
 * Sticky for the whole session — a visitor can browse the site and still get
 * credited when they eventually convert on the footer form.
 */
export const REFERRAL_STORAGE_KEY = 'ls_referral_code';

export function readStoredReferral() {
  try { return sessionStorage.getItem(REFERRAL_STORAGE_KEY) || ''; } catch { return ''; }
}

export default function useCaptureReferral() {
  const { search } = useLocation();
  useEffect(() => {
    try {
      const params = new URLSearchParams(search);
      const ref = params.get('ref');
      if (ref && /^SPLASH-REF-[A-Z0-9]{4,}$/i.test(ref)) {
        sessionStorage.setItem(REFERRAL_STORAGE_KEY, ref.toUpperCase());
      }
    } catch { /* noop */ }
  }, [search]);
}
